import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import store from './store'

window.tinyAPIKEY = 'e8w755v72e92ytu4phfw2z4wgycbeq7x2twygyk0umom9ot3'
window.user = JSON.parse(localStorage.getItem('user'))
  ? JSON.parse(localStorage.getItem('user'))
  : null

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <App />
  </Provider>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
